import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";
const path = "/management/mail";
export const mailLog = createCrudVuexModule({
  moduleName: "mailLog",
  namespaced: true,
  path: path,

  actions: {
    async readMail({ commit }, id) {
      try {
        const response = await rest.post(`/mail/${id}`);
        return response;
      } finally {
      }
    },
    async deleteAll() {
      await rest.delete(`${path}/deleteAll`);
    },
  },
});
